define('formkit/view/form.object/content/numeric.input.content.view',['require','exports','module','uikit/uikit','./base.input.content.view','../../../templates','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                = require('uikit/uikit'),
      BaseInputContentView = require('./base.input.content.view'),
      Templates            = require('../../../templates'),
      Radio                = require('backbone.radio');

  var PreviewAnswerView = BaseInputContentView.PreviewAnswerView.extend({
    internalViewOptions: BaseInputContentView.PreviewAnswerView.extendInternalViewOptions({
      inputView: function() {
        return {
          type: UIKit.InputCounter,
          placeholder: 'Please enter a number...',
          fluid: true,
          allowNegative: true,
        };
      },
    }),

    onInputViewInputFocus: function() {
      //enable the flag to allow invalid text notificatons
      this.canNotifyInvalid = true;

      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
    },

    onInputViewIncrementPress: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
    },

    onInputViewInputBlur: function() {
      //reset the flag for invalid text notifications
      this.canNotifyInvalid = false;

      if (!this.getOption('readonly')) {
        this.form.triggerEndEditAnswerEvent(this, this.model, {
          answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
        });
      }
    },

    onInputViewDecrementPress: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
    },

    //Listens for the object named "input" (the actual HTML numeric input element)  that is nested in the inputView
    // to fire the "input:text:invalid" event
    onInputViewInputInputTextInvalid: function(parentView, counterView, invalidText, errorMessage) {
      //we only want to fire one notification per attempt to interact with the input element, otherwise we could potentially
      // spam the user with notifications.  To ensure this happens only one time, we set a "canNotifyInvalid" flag to true when
      // the element is focused.  If a notification is fired, we toggle that to false so further keystrokes don't trigger
      // more notifications.
      if (this.canNotifyInvalid) {
        this.canNotifyInvalid = false;
        //Check to see if we're in a platform app with our notification service enabled
        if (Radio.channel('notificationService')) {
          Radio.request('notificationService', 'showNotification', errorMessage);
        } else {
          //If no notification sevice, go old school to notify the user
          window.alert(errorMessage);
        }
      }
    },
  });

  var NumericInputContentView = BaseInputContentView.extend({
    internalViewOptions: BaseInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
        };
      },
    }),
  });

  NumericInputContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = NumericInputContentView;
});

